import { Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

const ADMIN_EMAIL = 'pauline.clavelloux@gmail.com'

export function AdminEmailGuard({ children }: { children: React.ReactNode }) {
	const { user, isInitialized, loading } = useAuth()

	if (!isInitialized || loading) return null

	if (user?.email?.toLowerCase() !== ADMIN_EMAIL) {
		return <Navigate to="/dashboard" replace />
	}

	return <>{children}</>
}
